var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGuyana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4307C24.8366 32.4307 32 25.2672 32 16.4307C32 7.59411 24.8366 0.430664 16 0.430664C7.16344 0.430664 0 7.59411 0 16.4307C0 25.2672 7.16344 32.4307 16 32.4307Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.430664C13.1715 0.430664 10.5147 1.16579 8.20898 2.45391V30.4074C10.5148 31.6955 13.1715 32.4307 16.0003 32.4307C24.8368 32.4307 32.0003 25.2672 32.0003 16.4307C32.0003 7.59416 24.8368 0.430664 16.0003 0.430664Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25538 2.42773C7.24882 2.98555 6.30895 3.64855 5.45026 4.4023C5.53707 4.32617 5.62476 4.25092 5.71313 4.17667L17.9672 16.4308L5.71307 28.6849C5.62463 28.6107 5.53701 28.5354 5.4502 28.4593C6.30888 29.213 7.24882 29.876 8.25532 30.4339L31.9996 16.4308L8.25538 2.42773Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90438 3.26709C6.41644 3.60496 5.94782 3.96853 5.50125 4.35709L16 16.4307L5.50119 28.5043C5.94775 28.8929 6.41638 29.2565 6.90432 29.5943L29.2611 16.4307L6.90438 3.26709Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71371 4.17676C5.35802 4.47563 5.01477 4.78895 4.68652 5.11713L14.609 16.4309L4.68652 27.7446C5.01477 28.0729 5.35796 28.3863 5.71371 28.685L17.9678 16.4309L5.71371 4.17676Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 5.1167C-1.56212 11.3651 -1.56212 21.4958 4.68625 27.7442C7.26831 25.1621 9.75163 22.6788 16 16.4304L4.68625 5.1167Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.430664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGuyana);
export default __webpack_public_path__ + "static/media/flag_guyana.7509abc17542f36359c449a83da06ca3.svg";
export { ForwardRef as ReactComponent };